/** @jsxImportSource @emotion/react */
import React, { useCallback, useEffect, useState } from 'react';
import { jsx, css } from '@emotion/react';
import Textfield from '../textfield';
import Spinner from '@atlaskit/spinner';
import { ValidMessage, ErrorMessage } from 'components/form';
import { TextFieldProps } from '@atlaskit/textfield';
import { getOrganisationByVatIdentificationNumber } from './validateVatIdentificationNumber';
import { FieldInputProps, FieldRenderProps } from 'react-final-form';
import { colors } from '../theme';
import { useDebounce } from '../../hooks/useDebounce';
import { FormattedMessage } from 'components/i18n';

type Props = TextFieldProps & FieldRenderProps<string> & {};

const VatIdentificationNumberInput: React.FC<Props> = (props) => {
  const { value, meta } = props;
  const { valid } = meta;
  const [organisation, setOrganisation] = useState<any>(null);
  const debouncedValue = useDebounce(value, 400);
  const debouncedValid = useDebounce(valid, 400);
  useEffect(() => {
    (async () => {
      if (!debouncedValue ) return setOrganisation(null);
      if (!debouncedValid) return setOrganisation(null);
      const data = await getOrganisationByVatIdentificationNumber(
        debouncedValue as string
      );
      return setOrganisation(data);
    })();
  }, [debouncedValue, debouncedValid]);

  return (
    <React.Fragment>
      <Textfield
        {...props}
        // elemAfterInput={
        //   valid && organisation && organisation.isVatIdentificationNumberValid ? (
        //       <span css={css`display: inline; color:${colors.subtleText()}; width: 100%; font-size: 0.8rem; text-align: right; padding-right: 0.5rem;`}>{organisation.name}</span>
        //   ) : (
        //     <span />
        //   )
        // }
      />
      {organisation && organisation.isVatIdentificationNumberValid && (
      <ValidMessage>
        <FormattedMessage
          id="sale.VatIdentificationNumberInput.isValid"
          defaultMessage="The VAT ID number is valid"
        />
        {': '}{organisation.name}
      </ValidMessage>
    )}
      {organisation && !organisation.isVatIdentificationNumberValid && (
        <ErrorMessage>
          <FormattedMessage
            id="sale.VatIdentificationNumberInput.isInvalid"
            defaultMessage="The VAT ID number is not valid"
          />
        </ErrorMessage>
      )}
      {/*{input.value && meta.touched && !meta.validating && meta.valid && <ValidMessage > The VAT ID number is valid</ValidMessage>}*/}
    </React.Fragment>
  );
};

export default VatIdentificationNumberInput;
